import { TFundIsinAndWeight, TPayloadToSimulation } from "../../../services/OmniaService";
import { TSelectionState } from "../Tables/TableDestino";

export const FormatToSimulation = (data: TSelectionState) => {
    
    const wallet: TFundIsinAndWeight[] = [];
    const model: TFundIsinAndWeight[] = [];
    Object.entries(data).forEach(([_, fundSelected]) => {
        wallet.push({
            isin: !fundSelected.checked
                ? fundSelected.data.originalIsin
                : fundSelected.data.destinyIsin === ""
                    ? fundSelected.data.originalIsin
                    : fundSelected.data.destinyIsin,
            weight: (fundSelected.checked
                ?? fundSelected.data.destinyWeight === 0
                    ? fundSelected.data.destinyWeight
                    : fundSelected.data.destinyWeight
                        ? fundSelected.data.destinyWeight
                        : fundSelected.data.originalWeight
                    ) / 100
        });
        model.push({
            isin: fundSelected.data.originalIsin,
            weight: fundSelected.data.originalWeight / 100
        })
    })
    
    const payloadToSimulation: TPayloadToSimulation = {
        cartera: wallet,
        modelo: model,
        saveinstorage: false,
        full_ratios: true
    }

    return payloadToSimulation;
}